module.exports = __webpack_public_path__ + "images/f4792a49cc2603b15180ba9362bbb3dc.png";